export default "__VITE_ASSET__Ce3f0Nzn__"